// Generated types for ItemFlow
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { DeliveryMode, FlowType } from '../enums';

import { RFLPElementReadAPI, RFLPElementWriteAPI } from './rflpelement';
import { RFLPElementReadAPISchemaObject, RFLPElementWriteAPISchemaObject } from './rflpelement';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface ItemFlowReadAPI extends RFLPElementReadAPI {
  /** Should match both endpoint parameters' flow_type. Derivable from `item.flow_type` once a catalog Item is set — kept as the abstract-flow fallback while drafting. */
  flow_type?: FlowType;
  /** Free-form rate string, e.g. '2.5 kW', '5000 RPM'. Parsed via pint in simulation. */
  rate?: string | null;
  /** How this transfer relates to control ordering (SysML v2 'succession flow' as a configuration). Leave UNSET to derive from the payload's temporal_pattern (continuous→STREAMING, discrete→HANDOFF); set explicitly to override — BUFFERED for a queued/async discrete flow, HANDOFF for a continuous flow that gates its target. A HANDOFF flow IS the ordering, so do NOT add a parallel Succession beside it. */
  delivery?: DeliveryMode | null;
}

export interface ItemFlowWriteAPI extends RFLPElementWriteAPI {
  /** Should match both endpoint parameters' flow_type. Derivable from `item.flow_type` once a catalog Item is set — kept as the abstract-flow fallback while drafting. */
  flow_type?: FlowType;
  /** Free-form rate string, e.g. '2.5 kW', '5000 RPM'. Parsed via pint in simulation. */
  rate?: string | null;
  /** How this transfer relates to control ordering (SysML v2 'succession flow' as a configuration). Leave UNSET to derive from the payload's temporal_pattern (continuous→STREAMING, discrete→HANDOFF); set explicitly to override — BUFFERED for a queued/async discrete flow, HANDOFF for a continuous flow that gates its target. A HANDOFF flow IS the ordering, so do NOT add a parallel Succession beside it. */
  delivery?: DeliveryMode | null;
  /** Workspace catalog Item this flow carries. Must match both endpoints' items when all three are set (flush-checked). */
  item?: string;
  /** Unit override for `rate` when it differs from the Item's canonical_unit. Inherited from item.canonical_unit when unset. */
  unit?: string;
  /** Structural Connections that carry this functional flow (F→L realization). Link once the endpoint actions are performed by different LogicalParts and the connecting path exists. */
  realized_by?: string[];
  /** ActionOutputParameter this flow originates from. */
  source_parameter?: string;
  /** ActionInputParameter this flow terminates at. */
  target_parameter?: string;
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const ItemFlowReadAPISchema: z.ZodType<ItemFlowReadAPI> = RFLPElementReadAPISchemaObject.extend({
  flow_type: z.nativeEnum(FlowType).optional(),
  rate: z.string().nullable().optional(),
  delivery: z.nativeEnum(DeliveryMode).nullable().optional(),
}).passthrough();

export const ItemFlowWriteAPISchema: z.ZodType<ItemFlowWriteAPI> = RFLPElementWriteAPISchemaObject.extend({
  flow_type: z.nativeEnum(FlowType).optional(),
  rate: z.string().nullable().optional(),
  delivery: z.nativeEnum(DeliveryMode).nullable().optional(),
  item: z.string().optional(),
  unit: z.string().optional(),
  realized_by: z.array(z.string()).optional(),
  source_parameter: z.string().optional(),
  target_parameter: z.string().optional(),
}).passthrough();
